/*
 * Ryan O'Dowd
 * 2025-12-19
 * © Copyright 2025 Oakwood Software Consulting, Inc.  All Rights Reserved.
 */
import {
  Model,
  Q,
} from '@nozbe/watermelondb';
import {
  // @TODO: children,
  date,
  field,
  readonly,
} from '@nozbe/watermelondb/decorators';
import {
  Associations,
} from '@nozbe/watermelondb/Model';
import utils from './utils';

export default class Translation extends Model {
  static table = 'translations';
  static associations: Associations = {
    verse_texts: {type: 'has_many', foreignKey: 'translation_id'},
  };

  @field('translation_id') translationId;
  @readonly @date('updated_at') updatedAt;
  @field('is_full_download') isFullDownload; // @TODO: default value should be false (make this explicit...think it's fine by default for now)

  // @TODO: @children('verse_texts') verseTexts;

  static async fetchAll(db) {
    const collection = db.get(this.table);
    return await collection.query().fetch();
  }

  static async upsertAll(db, rows) {
    const collection = db.get(this.table);
    const newTranslationIds = rows.map((row) => row.translation_id);
    if (newTranslationIds.length === 0) {
      return;
    }
    const existingRecords = await collection.query(Q.where('translation_id', Q.oneOf(newTranslationIds))).fetch();
    const existingRecordsByTranslationId = Object.fromEntries(existingRecords.map((record) => [record.translationId, record]));
    await db.write(async () => {
      const updates = rows.map((row) => utils.prepareUpsertStatement(collection, existingRecordsByTranslationId[row.translation_id], row));

      await db.batch(updates);
    });
  }
};
